module.exports = __webpack_public_path__ + "static/media/cloud-shield.69adf420.svg";